/**
 * @jsxRuntime classic
 */
/** @jsx jsx */
import { Fragment, memo } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { PrimaryButtonSkeleton } from '../PrimaryButton/skeleton';
var primaryButtonSkeletonStyles = css({
  marginInlineEnd: "var(--ds-space-150, 12px)",
  marginInlineStart: "var(--ds-space-150, 12px)"
});

// Internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var PrimaryItemsContainerSkeleton = /*#__PURE__*/memo(function (_ref) {
  var count = _ref.count;
  return jsx(Fragment, null, Array.from({
    length: count
  }, function (_, index) {
    return jsx(PrimaryButtonSkeleton, {
      key: index,
      css: primaryButtonSkeletonStyles
    });
  }));
});